import { type TeamState } from "./state";

export const initialState: TeamState = {
  roster: [],
  isPending: false,
  isRejected: false,
  deliveries: [],
  isDeliveriesPending: false,
  isDeliveriesRejected: false,
};
